
  import directusRuntime$CDRnPxgNRfmBHAOA7kDE2H2omE0DP4BptTKgEPYg7A4 from '/Users/pramos/Documents/repositories/bvb_contractors/node_modules/.pnpm/@nuxt+image@2.0.0_@netlify+blobs@9.1.2_db0@0.3.4_ioredis@5.11.1_magicast@0.5.3/node_modules/@nuxt/image/dist/runtime/providers/directus'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "directus",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2,
    1,
    2
  ],
  "format": [
    "png",
    "webp"
  ]
},
    /** @type {"directus"} */
    provider: "directus",
    providers: {
        ['directus']: { setup: directusRuntime$CDRnPxgNRfmBHAOA7kDE2H2omE0DP4BptTKgEPYg7A4, defaults: {"baseURL":"https://consus-cms.ridiculousengineering.com/assets/"} }
    }
  }
